import type { GoogleLocation } from "./types";

/**
 * An unlinked ficha still exists. Null is the canonical "not yet linked"
 * state; it must not be presented as a failed Google readback.
 * Empty arrays from successful GET are valid. Malformed responses are unknown.
 */
export function verifiedGoogleLocationReadback(value: unknown): value is GoogleLocation[] {
  return Array.isArray(value)
    && value.length <= 1000
    && value.every(location =>
      location !== null
      && typeof location === "object"
      && typeof location.title === "string"
      && (location.location_id === null
        || (typeof location.location_id === "string" && location.location_id.length > 0))
      && (location.id === undefined || typeof location.id === "string"));
}
